<template lang="pug">
.edi-template
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h2.primary--text {{$t('GenerateCustomLogs.generateCustomLogsTemplate')}}
    v-row
      v-col(cols="6")
        v-text-field(
          :label="$t('GenerateCustomLogs.eventName')"
          :value="(value || {}).eventName",
          @input="setEventName",
        )
</template>

<style type="text/css">
span.text-size{
  overflow: hidden;
}
</style>

<script>

export default {
  props: ['value'],
  data: function ()  {
    return {
      initObject: {
        type: 'Generate Custom Logs',
        body: '@{}@Model.ToJson()',
        eventName: '',
        entity: '',
        isRazor: true
      },
      instance: {}
    }
  },
  computed: {
    schema() {
      return this.$store.state.schema.all;
    },
  },
  watch: {
    instance: {
      deep: true,
      handler(val) {
        val.entity = this.value.entity
        val.eventName = this.value.eventName
        this.$emit('input', val)
      },
    },
  },
  methods: {
    setEventName(val) {
      const input = { ...this.initObject, ...this.value, eventName: val };
      this.$emit('input', input);
    },
  },
  created() {
    this.instance = { ...this.initObject, ...this.value };
  },
}
</script>
